import { useTranslation } from "react-i18next";
import TalentSummaryCard from "./TalentSummaryCard";
import EmptyStateText from "./EmptyStateText";

const TalentUpcomingWork = () => {
  const { t } = useTranslation("talentProfile");

  return (
    <TalentSummaryCard title={t("profileSummary.upcomingWork")} divider>
      <EmptyStateText placeholder />
    </TalentSummaryCard>
  );
};

export default TalentUpcomingWork;
